import slice from './slice';

export const {
    addStructure, changeProteinFamily,
    changeTarget, removeStructure,
    setCompoundTableState, setScoringTableState,
    setSidePanelWidth,
    removeAllStructures, reset,
    setCoralMapState, setTableState,
    setTargetInfo, setActiveChart,
} = slice.actions;

export default slice.reducer;
